const Login = {
    data() {
        return {
            email: "",
            isValidEmail: false,
            pin: "",
            token: "",
            resendEmailTimer: 0,
            emailError: "",
            pinError: "",
            needChallenge: false,
            captchaID1: null,
            captchaID2: null,
        };
    },
    methods: {
        callStartLogin(event) {
            // resendEmail() calls this without an event
            event?.preventDefault();

            if (!this.email) {
                return;
            }
            let bodyContent = {
                email: this.email
            };
            if (this.needChallenge) {
                bodyContent.h_captcha_response = hcaptcha.getResponse(this.captchaID1);
            }

            http.postJson("/api/login/start", bodyContent)
                .then((response) => response.json())
                .then((data) => {
                    if (data.code === 200) {
                        this.needChallenge = false;
                        this.isValidEmail = true;
                        this.token = data.data["customer-pin-token"];
                        this.setResendEmailTimer();
                        this.emailError = "";
                    } else if (data.errors && data.errors.email) {
                        this.emailError = data.errors.email[0];
                    } else if (data.errors && data.errors.first_name) {
                        // no customer with this email (the core asks for the registration fields)
                        authHandoff.set({email: this.email});
                        document.location = (window.SHOP_BASE || "") + "/register";
                    }else if (data["need-challenge"]){
                        let _this = this;
                        window.loadCaptcha(() => {
                            if (this.needChallenge) {
                                hcaptcha.reset(this.captchaID1);
                            } else {
                                _this.needChallenge = data["need-challenge"];
                                _this.captchaID1 = hcaptcha.render(_this.$refs.captcha1, {
                                    sitekey: process.env.MIX_HCAPTCHA_TOKEN,
                                });
                            }
                        });
                    }else{
                        // any other failure (expired page, server error) is not "no account":
                        // sending an existing customer to the registration form loops them
                        this.emailError = data.message || "Error";
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
        callValidateLogin(event) {
            event.preventDefault();
            let bodyContent = {
                pin: this.pin || "",
                token: this.token || ""
            };
            if (this.needChallenge) {
                bodyContent.h_captcha_response = hcaptcha.getResponse(this.captchaID2);
            }
            // if (!this.pin) {
            //     return;
            // }
            http.postJson("/api/login/validate", bodyContent)
                .then((response) => response.json())
                .then((data) => {
                    if (data.code === 200) {
                        let token = data.data["customer-api-token"];
                        Cookies.setItem("login_token", token);
                        window.location.href =
                            !document.referrer ||
                            document.referrer.includes("register")
                                ? window.location.origin
                                : document.referrer; //last page visited or root
                        this.pinError = "";
                    } else if (data.errors && data.errors.pin) {
                        this.pinError = data.errors.pin[0];
                    }else if (data["need-challenge"]){
                        let _this = this;
                        window.loadCaptcha(() => {
                            if (this.needChallenge) {
                                hcaptcha.reset(this.captchaID2);
                            } else {
                                _this.needChallenge = data["need-challenge"];
                                _this.captchaID2 = hcaptcha.render(_this.$refs.captcha2, {
                                    sitekey: process.env.MIX_HCAPTCHA_TOKEN,
                                });
                            }
                        });
                    } else {
                        this.pinError = data.message || "Error";
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
        setResendEmailTimer() {
            this.resendEmailTimer = 10;
            let interval = setInterval(() => {
                this.resendEmailTimer--;
                if (this.resendEmailTimer <= 0) clearInterval(interval);
            }, 1000);
        },
        resendEmail() {
            if (this.resendEmailTimer > 0) {
                return;
            }
            this.callStartLogin();
        },
    },
    created() {
        // coming from the registration form: the email is known, and for an existing
        // customer the core has already sent the login code -> straight to the PIN step
        const handoff = authHandoff.take();
        if (handoff) {
            this.email = handoff.email || "";
            if (handoff.token) {
                this.token = handoff.token;
                this.isValidEmail = true;
                this.setResendEmailTimer();
            }
        }
        let registerSuccess = localStorage.getItem("registerSuccess");
        if (registerSuccess) {
            localStorage.setItem("registerSuccess", "");
            setTimeout(function () {
                alert("user created successfully");
            }, 0);
        }
    },
};

// Global cart object
const LOGIN = {
    vue: null,
    loaded: false,
    load() {
        if(this.loaded){
            return;
        }
        if (document.getElementById("login") !== null) {
            this.loaded = true;
            this.vue = Vue.createApp(Login).mount("#login");
            forms.load();
        }
    },
};
window.LOGIN = LOGIN;

window.addEventListener("DOMContentLoaded", () => {
    LOGIN.load();
});
window.addEventListener("load", () => {
    LOGIN.load();
});

if (document.readyState !== "loading") {
    LOGIN.load();
}
